module.exports = __webpack_public_path__ + "static/media/kbc-app-icon.7c425bd5.png";